/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Lush_Yak_SoarInputs */

const en_dry_lush_yak_soar = /** @type {(inputs: Dry_Lush_Yak_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This can take some time...`)
};

const de_dry_lush_yak_soar = /** @type {(inputs: Dry_Lush_Yak_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das kann einige Sekunden dauern...`)
};

/**
* | output |
* | --- |
* | "This can take some time..." |
*
* @param {Dry_Lush_Yak_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dry_lush_yak_soar = /** @type {((inputs?: Dry_Lush_Yak_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Lush_Yak_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dry_lush_yak_soar(inputs)
	return de_dry_lush_yak_soar(inputs)
});